import { graphql, Link } from "gatsby"
import React from "react"
import Layout from "src/components/Layout"
import ProjectCard from "src/components/cards/ProjectCard"

export default function Projects({ data }) {
  const projects = data.projects.nodes
  return (
    <Layout>
      <div className="container">
        <h1 className="heading">Our Work</h1>
        <div className="card_grid">
          {projects.map(project => (
            <Link to={`/projects/${project.frontmatter.slug}`} key={project.id}>
              <ProjectCard
                title={project.frontmatter.title}
                details={project.frontmatter.description}
                image={project.frontmatter.thumb}
              />
            </Link>
          ))}
        </div>
      </div>
    </Layout>
  )
}

export const query = graphql`
  query ProjectsPage {
    projects: allMarkdownRemark(
      sort: { fields: frontmatter___date, order: DESC }
    ) {
      nodes {
        frontmatter {
          slug
          title
          description
          thumb {
            childImageSharp {
              gatsbyImageData
            }
          }
        }
        id
      }
    }
  }
`
